import React from "react";
import ThankYou from "@components/templates/ThankYou";

export default function ThankYouScreen() {
  return <ThankYou />;
}
